(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ivory-collection-accordion"] && !Shopify.designMode) return;
  try {
    
function initCollectionAccordions(root){root.querySelectorAll('[data-collection-accordion]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const panels=[...section.querySelectorAll('[data-accordion-panel]')];const activate=panel=>panels.forEach(item=>item.classList.toggle('is-active',item===panel));panels.forEach(panel=>{panel.addEventListener('pointerenter',event=>{if(event.pointerType!=='touch')activate(panel)});panel.addEventListener('focus',()=>activate(panel));panel.addEventListener('shopify:block:select',()=>activate(panel))})})}initCollectionAccordions(document);document.addEventListener('shopify:section:load',event=>initCollectionAccordions(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ivory-collection-gallery"]) return;
  try {
    
document.querySelectorAll('[data-ic-category]').forEach(select=>select.addEventListener('change',()=>{if(select.value)window.location.assign(select.value);}));
document.querySelectorAll('[data-ic-sort]').forEach(select=>select.addEventListener('change',()=>select.form.requestSubmit()));
document.addEventListener('click',event=>{document.querySelectorAll('.ic-filter[open]').forEach(details=>{if(!details.contains(event.target))details.open=false;});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ivory-contact-volume"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-contact-atelier]').forEach(page=>{
 const model=page.querySelector('[data-contact-model]');const photo=page.querySelector('.ica-stage-photo');const rotate=page.querySelector('[data-contact-rotate]');
 page.querySelectorAll('[data-contact-view]').forEach(button=>button.addEventListener('click',()=>{const isPhoto=button.dataset.contactView==='photo';model.hidden=isPhoto;photo.hidden=!isPhoto;rotate.disabled=isPhoto;page.querySelectorAll('[data-contact-view]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));}));
 rotate.addEventListener('click',()=>{const on=rotate.getAttribute('aria-pressed')!=='true';rotate.setAttribute('aria-pressed',String(on));model.classList.toggle('is-rotating',on);});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ivory-footer"]) return;
  try {
    
function initRevealFooters(root){root.querySelectorAll('[data-footer-shell]').forEach(shell=>{if(shell.dataset.ready)return;shell.dataset.ready='true';const footer=shell.querySelector('[data-reveal-footer]'),button=footer.querySelector('[data-back-to-top]');const measure=()=>{document.body.classList.remove('ifs-curtain');document.body.style.removeProperty('--ifs-height');const height=footer.getBoundingClientRect().height;if(innerWidth>1100&&height<=innerHeight&&!matchMedia('(prefers-reduced-motion: reduce)').matches){document.body.style.setProperty('--ifs-height',height+'px');document.body.classList.add('ifs-curtain')}};button.addEventListener('click',()=>{window.scrollTo({top:0,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})});window.addEventListener('resize',measure);document.fonts.ready.then(measure);measure()})}initRevealFooters(document);document.addEventListener('shopify:section:load',event=>initRevealFooters(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ivory-header"]) return;
  try {
    
document.querySelectorAll('.iv-mega').forEach(menu=>{
  document.addEventListener('click',event=>{if(menu.open&&!menu.contains(event.target)){menu.open=false;}});
  menu.addEventListener('keydown',event=>{if(event.key==='Escape'){menu.open=false;menu.querySelector('summary').focus();}});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ivory-reference-page"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => root.querySelectorAll('[data-logo-river]').forEach((section) => {
    if (section.dataset.riverReady) return;
    section.dataset.riverReady = 'true';
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reduced.matches) return;
    section.classList.add('is-enhanced');
    let hovered = false, visible = true, frame = 0, last = 0;
    const rows = [...section.querySelectorAll('[data-river-row]')].map((row, index) => {
      const originals = [...row.querySelectorAll('.iriver__card')];
      const holder = row.querySelector('.iriver__cards');
      for (let copy = 0; copy < 2; copy++) originals.forEach((original) => {
        const clone = original.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-shopify-editor-block');
        holder.appendChild(clone);
      });
      return { row, index, cards: [...holder.querySelectorAll('.iriver__card')], phase: 0, width: 0, height: 0, cardWidth: 0, cardHeight: 0, spacing: 0 };
    });
    const measure = () => {
      if (section.dataset.pageType === 'page') section.style.setProperty('--river-header-height', Math.min(180, section.getBoundingClientRect().top + window.scrollY) + 'px');
      rows.forEach((state) => {
      state.width = state.row.clientWidth;
      state.height = state.row.clientHeight;
      const card = state.cards[0];
      if (!card) return;
      state.cardWidth = card.offsetWidth;
      state.cardHeight = card.offsetHeight;
      state.spacing = state.cardWidth * (state.index === 0 ? 1.3 : 1.1);
      });
    };
    const draw = (state) => {
      const { width, height, cardWidth, cardHeight, spacing, cards } = state;
      if (!cards.length || !width) return;
      const cycle = cards.length * spacing;
      cards.forEach((card, i) => {
        const raw = width / 2 + (i - 1) * spacing + state.phase;
        const x = ((raw + spacing * 1.5) % cycle + cycle) % cycle - spacing * 1.5;
        const distance = (x - width / 2) / (width / 2);
        const strength = Math.max(0, 1 - distance * distance);
        const scale = state.index === 0 ? 0.92 + 0.30 * strength * strength : 0.96 + 0.08 * strength;
        const y = height * 0.59 - Math.min(1.5, distance * distance) * height * 0.29;
        card.style.transform = 'translate3d(' + (x - cardWidth / 2) + 'px,' + (y - cardHeight / 2) + 'px,0) scale(' + scale + ')';
        card.style.zIndex = String(Math.round(strength * 10) + 1);
        card.style.visibility = x < -cardWidth || x > width + cardWidth ? 'hidden' : 'visible';
      });
    };
    const tick = (time) => {
      const dt = last ? Math.min((time - last) / 1000, 0.05) : 0;
      last = time;
      rows.forEach((state) => {
        if (!hovered && !document.hidden && !reduced.matches) state.phase += dt * (state.index === 0 ? -45 : 38);
        draw(state);
      });
      frame = visible && !document.hidden ? requestAnimationFrame(tick) : 0;
    };
    const start = () => { if (!frame && visible && !document.hidden) { last = 0; frame = requestAnimationFrame(tick); } };
    section.addEventListener('pointerover', (event) => { hovered = Boolean(event.target.closest('.iriver__card')); });
    section.addEventListener('pointerleave', () => { hovered = false; });
    rows.forEach((state) => state.row.querySelectorAll('[data-river-direction]').forEach((button) => button.addEventListener('click', () => { state.phase -= Number(button.dataset.riverDirection) * state.spacing; draw(state); })));
    const resize = new ResizeObserver(() => { measure(); rows.forEach(draw); });
    resize.observe(section);
    const intersection = new IntersectionObserver((entries) => {
      visible = entries[0].isIntersecting;
      if (visible) start();
      else { cancelAnimationFrame(frame); frame = 0; last = 0; }
    });
    intersection.observe(section);
    const visibility = () => { if (document.hidden) { cancelAnimationFrame(frame); frame = 0; } else start(); };
    document.addEventListener('visibilitychange', visibility);
    const motion = () => {
      if (reduced.matches) { cancelAnimationFrame(frame); frame = 0; section.classList.remove('is-enhanced'); rows.forEach((state) => state.cards.forEach((card) => { card.style.transform = ''; card.style.visibility = ''; if (card.getAttribute('aria-hidden') === 'true') card.hidden = true; })); }
      else { section.classList.add('is-enhanced'); rows.forEach((state) => state.cards.forEach((card) => { card.hidden = false; })); measure(); start(); }
    };
    reduced.addEventListener('change', motion);
    section.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {
      cancelAnimationFrame(frame); resize.disconnect(); intersection.disconnect();
      document.removeEventListener('visibilitychange', visibility); reduced.removeEventListener('change', motion);
    }, { once: true });
    measure(); rows.forEach(draw); start();
  });
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ivory-space-impact"] && !Shopify.designMode) return;
  try {
    
(() => {
  const bind = (root) => {
    root.querySelectorAll('.isl-wave:not([data-wave-ready])').forEach((wave) => {
      wave.dataset.waveReady = 'true';
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
      wave.classList.add('is-ready');
      const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        wave.classList.add('is-visible');
        observer.disconnect();
      }, { threshold: 0.15 });
      observer.observe(wave);
      wave.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => observer.disconnect(), { once: true });
    });
  };
  bind(document);
  document.addEventListener('shopify:section:load', (event) => bind(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ivory-video-hero"] && !Shopify.designMode) return;
  try {
    
function initHeroFilm(root){root.querySelectorAll('[data-hero-film]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const video=section.querySelector('video');if(video&&matchMedia('(prefers-reduced-motion: reduce)').matches)video.pause()})}
initHeroFilm(document);document.addEventListener('shopify:section:load',event=>initHeroFilm(event.target));

  } catch(e) { console.error(e); }
})();
})();
